import RechargeCooldownLabel from "../../RechargeCooldownLabel";
import { RechargeCooldownError } from "@/store/rechargeCooldown";
import React, { useEffect, useRef } from "react";
import "../flatRecharge.less";
import { useTranslationPlus } from "@/Core/i18n/useTranslationPlus";
import {
  useChangeFlatRecharge,
  useWalletAll,
  useWalletRechargeFlat,
} from "@/store/walletStore";
import FormUI from '@/componentsUI/Form';
import FromItemPlus from "@/components/FormItemPlus/FromItemPlus";
import LoadingUI from "@/componentsUI/LoadingUI/LoadingUI";
import FlatPix from "../pix/FlatPix";
import ButtonUI from "@/componentsUI/Button";
import { AmountMultiplierConversion } from "@/Core/utils/currencyDealCenter";
import useDialogManager from "@/utils/useDialogManager";
import DepositCurrency from "../compoments/depositCurrency/DepositCurrency";
import DepositWay from "../compoments/depositWay/DepositWay";
import MobileInput from "../compoments/mobileInput/MobileInput";
import { useUserInfo } from "@/store/userInfo";
import { getUserMobile } from "@/utils/mobileUtils";
import { useRechargeCurrency } from "../../useRechargeCurrency";
import { useRechargePaymentMethod } from "../useRechargePaymentMethod";
import { feedback } from "@/utils/feedback";

const FlatRechargeTanzania = () => {
  const { t } = useTranslationPlus();
  const { data: wallets } = useWalletAll();
  const [form] = FormUI.useForm();
  const { params, displayCurrencyType, changeRecharge } = useRechargeCurrency(wallets?.flat, form);
  const { isValidating, data, error, mutate } = useChangeFlatRecharge(params);
  const { trigger, isMutating, isRechargeBlocked } = useWalletRechargeFlat();
  const { openDialogIFrame } = useDialogManager();
  const formValidator = useRef(null);
  const { rule, changeType } = useRechargePaymentMethod(data?.payParams, form, params?.currencyType);
  const { data: userInfo } = useUserInfo();

  function recharge() {
    if (!rule || error || isValidating || isMutating || isRechargeBlocked) return;
    formValidator.current = true;
    form
      .validate()
      .then((v) => {
        const selectedWallet = wallets?.flat?.find(
          (wallet) => wallet.currencyType === v?.walletType
        );
        trigger({
          currencyType: selectedWallet?.serverCurrencyType || v?.walletType,
          money: AmountMultiplierConversion(v?.amount, {
            currencyType: selectedWallet?.currencyType || v?.walletType,
            serverCurrencyType: selectedWallet?.serverCurrencyType,
          }),
          payCode: v?.payType?.data?.payCode,
          mobile: v?.mobile,
          rechargeMobileUserId: userInfo?.userId,
        })
          .then((res) => {
            if (res?.payUrl) {
              openDialogIFrame({
                title: t("Wallet.Wallet_PayUrlTitle"),
                url: res?.payUrl,
                type: "pay",
              });
            } else {
              feedback.success(t("Wallet.Payment request submitted successfully"));
            }
          })
          .catch((e) => {
        if (e instanceof RechargeCooldownError) return;
            feedback.error(t(e?.code));
          });
      })
      .finally(() => {
        formValidator.current = false;
      });
  }

  useEffect(() => {
    const mobile = getUserMobile(userInfo?.mobile, userInfo?.userId);
    if (mobile) {
      form.setFieldValue("mobile", mobile);
    }
  }, [userInfo]);

  return (
    <div className="flat-Recharge">
      <FormUI form={form} layout={"vertical"} autoComplete={"off"}>
        <LoadingUI
          isLoading={isValidating}
          error={error}
          dataList={data}
          retryFunc={mutate}
          className="wallet-flat-loading-state"
        >
          <div className="deposit-row">
            <FromItemPlus
              field={"walletType"}
              label={t("Wallet.Currency")}
              className="deposit-currency-item"
            >
              <DepositCurrency
                currencys={wallets?.flat}
                onChange={(_value: any, option: any) => {
                  changeRecharge(option?._index);
                }}
              />
            </FromItemPlus>
          </div>
          <div className="deposit-method-section">
            <FromItemPlus
              field={"payType"}
              label={t("Wallet.Method")}
              className="deposit-way-item"
            >
              <DepositWay payParams={data?.payParams} onChange={changeType} />
            </FromItemPlus>
          </div>
          <div className="deposit-mobile-section">
            <FromItemPlus
              field={"mobile"}
              label={t("Wallet.Mobile Number")}
              className="deposit-mobile-item"
              rules={[
                {
                  required: true,
                  message: t("Wallet.Please enter mobile number"),
                },
                {
                  validator: (value, cb) => {
                    if (value && value.length !== 9) {
                      return cb("Mobile number must be 9 digits");
                    }
                    return cb();
                  },
                },
              ]}
            >
              <MobileInput disabled={false} />
            </FromItemPlus>
            <div className="important-notice">
              {t("Wallet.DepositPhoneNotice")}
            </div>
          </div>
          <FlatPix
            data={data}
            form={form}
            currencyType={displayCurrencyType}
            serverCurrencyType={params?.currencyType}
            formValidator={formValidator}
            rule={rule}
          />
        </LoadingUI>
      </FormUI>
      <ButtonUI
        className={`recharge-btn`}
        data-recharge-spin-entry-anchor="deposit-submit"
        type="primary"
        loading={isMutating}
        disabled={!rule || !!error || isValidating || isMutating || isRechargeBlocked}
        onClick={recharge}
      >
        <RechargeCooldownLabel>{t("Wallet.Deposit")}</RechargeCooldownLabel>
      </ButtonUI>
    </div>
  );
};

export default FlatRechargeTanzania;
